import React , { Component } from 'react';

import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {withRouter} from 'react-router';
import HeaderMenuSty from './headerMenu.module.css';
import {headerMenuRouterAction} from '../../actions/header/headerMenuRouterAction';
import {fetch_bussinessList,fetch_bussinessConData} from '../../actions/bussiness/createBussinessListAction';
import {fetch_jw_list} from '../../actions/aboutJingWei/createJWListAction';
import {fetch_policy} from '../../actions/aboutPolicy/policyAction';
import {fetch_policy_type} from '../../actions/aboutPolicy/policyTypeAction';
import {baseUrl} from '../../contants/index';
import {getFirmIntro} from '../Content/service';

import menuItemSelectedBg from '../../images/logo_menu_hovered.png';
// import bussiness_item1_bgm from '../../images/bussiness_item1_bgm.png';
// import bussiness_item2_bgm from '../../images/bussiness_item2_bgm.png';
// import bussiness_item3_bgm from '../../images/bussiness_item3_bgm.png';
// import bussiness_item4_bgm from '../../images/bussiness_item4_bgm.png';
// import bussiness_item5_bgm from '../../images/bussiness_item5_bgm.png';

import service_team_icon from '../../images/service_team.png';
import service_control_icon from '../../images/service_control.png';
import service_managerFlow_icon from '../../images/service_manager_flow.png';
import service_plan_icon from '../../images/service_plan.png';
import service_concept_icon from '../../images/service_concept.png';
import service_platform_icon from '../../images/service_platform.png';



const menuListData=[
    {key:0, itemName:'网站首页'},
    {key:1, itemName:'走进经纬通达'},
    {key:2, itemName:'业务范围'},
    {key:3, itemName:'政策咨询'},
    {key:4, itemName:'新闻焦点'},
    {key:5, itemName:'科技财税联盟'},
    {key:6, itemName:'招贤纳士'},
    {key:7, itemName:'联系我们'},
];

// const gotoJW_menuData=[
//     {key:0, itemName:'关于我们'},
//     {key:1, itemName:'服务特色'},
//     {key:2, itemName:'董事长致辞'},
//     {key:3, itemName:'经纬通达大事记'},
//     {key:4, itemName:'荣誉资质'},
//     {key:5, itemName:'联系我们'},
//     {key:6, itemName:'项目案例'},
//     {key:7, itemName:'合作伙伴'},
//     {key:8, itemName:'留言评论'}
// ];

const slogansData=[
    {key:0, solganType:'经营理念:', solganCon:'成人达己 合作共赢' },
    {key:1, solganType:'公司承诺:', solganCon:'客户公司零成本零风险'},
    {key:2, solganType:'经营特色:', solganCon:'多元化协作 至诚式服务 合理化收费 前瞻性策划'},
    {key:3, solganType:'市场理念:', solganCon:'做一项业务 担一份责任 拓一片市场 交一方朋友'},
];

// const bussinessListData=[
//     {key:0, itemName:'资质申请', con:['国家级高新技术企业认定','国家级企业技术中心','北京市企业技术中心'], item_bgm:bussiness_item1_bgm},
//     {key:1, itemName:'资金申请', con:['研发费用加计扣除','北京市高新技术成果转化','中关村现代化服务业扶持资金'], item_bgm:bussiness_item2_bgm},
//     {key:2, itemName:'财税服务', con:['税收服务','审计业务','研发费用加计扣除'], item_bgm:bussiness_item3_bgm},
//     {key:3, itemName:'咨询服务', con:['人力咨询服务'], item_bgm:bussiness_item4_bgm},
//     {key:4, itemName:'其他服务', con:['孵化器运营','特产销售'], item_bgm:bussiness_item5_bgm},
// ];

// const gxqyData=[
//     {key:0, type:'高新企业',itemTitle:'中国技术创业协会科技财税服务联盟成立大会...'},
//     {key:1, type:'高新企业',itemTitle:'2018年第二批拟认定高新技术企业名单'},
//     {key:2, type:'高新企业',itemTitle:'中国技术创业协会科技财税服务'},
//     {key:3, type:'高新企业',itemTitle:'严查!高新技术企业现场走访看什么，如何应对'},
//     {key:4, type:'高新企业',itemTitle:'2018年第二批拟认定高新技术企业名单'},
//     {key:5, type:'高新企业',itemTitle:'中国技术创业协会科技财税服务联盟成立'},
//     {key:6, type:'高新企业',itemTitle:'2018年第二批拟认定高新技术企业名单'},
//     {key:7, type:'高新企业',itemTitle:'中国技术创业协会科技财税'},
//     {key:8, type:'高新企业',itemTitle:'2018年第二批拟认定高新技术企业名单'},
// ];

// const zjxmData=[
//     {key:0, type:'资金项目',itemTitle:'中国技术创业协会科技财税服务联盟成立大会...'},
//     {key:1, type:'资金项目',itemTitle:'2018年第二批拟认定高新技术企业名单'},
//     {key:2, type:'资金项目',itemTitle:'中国技术创业协会科技财税服务联盟成立大会...'},
// ];

// const zscqData=[
//     {key:0, type:'知识产权',itemTitle:'中国技术创业协会科技财税服务联盟成立大会...'},
//     {key:1, type:'知识产权',itemTitle:'2018年第二批拟认定高新技术企业名单'},
//     {key:2, type:'知识产权',itemTitle:'中国技术创业协会科技财税服务联盟成立大会...'},
// ];

// const zhzxData=[
//     {key:0, type:'综合资讯',itemTitle:'中国技术创业协会科技财税服务联盟成立大会...'},
//     {key:1, type:'综合资讯',itemTitle:'2018年第二批拟认定高新技术企业名单'},
//     {key:2, type:'综合资讯',itemTitle:'中国技术创业协会科技财税服务联盟成立大会...'},
// ];

// const ztlbData=[
//     {key:0, type:'专题列表', itemTitle:'专题内容一'},
//     {key:1, type:'专题列表', itemTitle:'专题内容二'},
// ];

const featureServiceData=[
    {key:0,itemName:'专业化的资深顾问团队',itemIconBgColor:'#3186F0',itemIcon:service_team_icon},
    {key:1,itemName:'前瞻性的风险把控策划',itemIconBgColor:'#74CB67',itemIcon:service_control_icon},
    {key:2,itemName:'定制式的差异化服务方案',itemIconBgColor:'#FEC92C',itemIcon:service_plan_icon},
    {key:3,itemName:'规范化的服务管理流程',itemIconBgColor:'#FF7277',itemIcon:service_managerFlow_icon},
    {key:4,itemName:'一站式的高效服务平台',itemIconBgColor:'#9D7BFF',itemIcon:service_platform_icon},
    {key:5,itemName:'低风险的成人达己理念',itemIconBgColor:'#3186F0',itemIcon:service_concept_icon},
];

class HeaderMenu extends Component{

    state={
        selectedIndex:0, //默认选中第一个
        gotoJwKey:1,
        bussinessScopeKey:2,
        policyInfoKey:3,
        isShowAboutJW:false,  //控制三个悬浮框的显示
        isShowBussinessScopre:false,
        isShowPolicyInfo:false,

        bussinessScopeListData:[],
        bussinessScopeListItemData:[],

        jwListData:[], //经纬列表数据,
        firmIntro:null, //走进经纬通达的公司简介数据
    }


    static defaultProps={
        currentSelectIndex:0,
    }

    constructor(props){
        super(props);

        this.onMenuItemMouseLeave=this.onMenuItemMouseLeave.bind(this);
        this.onMenuItemMouseOver=this.onMenuItemMouseOver.bind(this);
        this.onMenuItemClick=this.onMenuItemClick.bind(this);
        this.onRecruitmentRouterListener=this.onRecruitmentRouterListener.bind(this);
        this.onJingWeiNewsClick=this.onJingWeiNewsClick.bind(this);
        this.onBussinessNewsClick=this.onBussinessNewsClick.bind(this);
        this.onPolicyNewsClick=this.onPolicyNewsClick.bind(this);
        this.isIE11Browers=this.isIE11Browers.bind(this);
    }

    async componentWillMount(){
        const {data}=await getFirmIntro();
        data.list.map((item,index)=>{
            if (item.id === 14 && item.title === "公司简介")
                this.setState({firmIntro: item.value});
        })
    }

    componentDidMount=()=>{
        this.props.fetch_bussinessList('get',null);
        this.props.fetch_bussinessConData('get',null);
        this.props.fetch_jw_list('get',null);
        this.props.fetch_policy('get',null);
        this.props.fetch_policy_type('get',null);

        this.setState({
            selectedIndex:this.props.currentSelectIndex,
        })


    }

    componentWillReceiveProps=()=>{

    }

    onMenuItemMouseOver=(index)=>{
        // console.log('鼠标划入',index);
        this.setState({
            isShowAboutJW:index==1,
            isShowBussinessScopre:index==2,
            isShowPolicyInfo:index==3 && this.props.policyData.length !==0,
            selectedIndex: index
        });
    }

    onMenuItemMouseLeave=()=>{
        // console.log('鼠标离开');
        this.setState({
            isShowAboutJW:false,
            isShowBussinessScopre:false,
            isShowPolicyInfo:false,
            selectedIndex: -1
        });
    }

    onMenuItemClick=(index)=>{
        Promise.resolve().then(()=>{
            this.setState({
                selectedIndex:index,
            })
            this.props.jumpRouterAction(index);
        }).then(()=>{
            if(this.props.headerMenuRouterPath.includes('about')){
                this.onJingWeiNewsClick(0,this.props.jw_list_data[0].id,this.props.jw_list_data[0].title)
            }else if(this.props.headerMenuRouterPath.includes('bussiness')){
                let ids=[];
                this.props.bussinessItemConData.map((item,index)=>{
                    if(item.cate_id === this.props.bussinessListData[0].id)
                        ids.push(item.id);
                });
                this.props.history.push({pathname:`/bussiness/${ids[0]}`});
            }else{
                this.props.history.push(this.props.headerMenuRouterPath);
            }
        }).then(()=>{
            this.onRecruitmentRouterListener();
        })
        if (index!==0) {
            if(!this.isIE11Browers()){
                window.screenY=300;
            }
            window.scrollTo(0,300);
        }

        this.onMenuItemMouseLeave();
    }

    onRecruitmentRouterListener=()=>{
        let anchor_contact_us=document.getElementById(this.props.history.location.hash);
        if(anchor_contact_us){
            anchor_contact_us.scrollIntoView();
        }
    }

    // 走进经纬通达悬浮框的标题点击监听
    onJingWeiNewsClick=(index, id, title)=>{
        this.props.history.push({pathname:`/about/${id}/${title}`});
        this.onMenuItemMouseLeave();
        if( !this.isIE11Browers()){
            window.screenY=300;
        }
        window.scrollTo(0,300)
    }

    // 业务范围悬浮框的标题点击监听
    onBussinessNewsClick=(id)=>{
        this.props.history.push({pathname:`/bussiness/${id}`});
        this.onMenuItemMouseLeave();
        window.scrollTo(0,300)
    }


    // 政策资讯的新闻标题点击监听事件
    onPolicyNewsClick=(cate_id,cate_desc,id)=>{
        // this.props.history.push('/policy/detail_policy/'+id);
        this.onMenuItemMouseLeave(); //收起悬浮框
        this.props.history.push({pathname:`/policy/more/${cate_id}/${cate_desc}/detail/${id}`})
        window.scrollTo(180,300)

    }

    // 政策咨询悬浮框的专题列表的监听事件
    onZtlbItemClick=()=>{
        this.props.history.push({ pathname:`/policy`});
        window.scrollTo(0,2000)
    }

    // 判断是否为IE11浏览器
    isIE11Browers=()=>{
        if (!!window.ActiveXObject || "ActiveXObject" in window){
            return true;
        }else{
            return false;
        }
    }

    render(){

        let menuItemSelectedSty={
            backgroundImage:`url(${menuItemSelectedBg})`,
        }
        let menuItemSelected_a_sty={
            color:'#FFFFFF',
        }

        let menuLis=menuListData.map(({key,itemName})=>{

            return(
                <li
                    key={key}
                    onMouseOver={()=>{this.onMenuItemMouseOver(key)}}
                    onMouseLeave={this.onMenuItemMouseLeave}
                    style={this.state.selectedIndex == key || this.props.currentSelectIndex == key ? menuItemSelectedSty : null}
                ><a onClick={()=>{this.onMenuItemClick(key)}} style={this.state.selectedIndex == key || this.props.currentSelectIndex == key ? menuItemSelected_a_sty:null}>{itemName}</a></li>
            );
        });;


        let jwListData=[];
        if(this.props.jw_list_data!=undefined){
            this.props.jw_list_data.sort((itemA,itemB)=>{
                return itemA.sort-itemB.sort;
            });

            this.props.jw_list_data.map((item,index)=>{
                let obj={key:index,id:item.id,title:item.title,content:item.content,status:item.status};
                jwListData.push(obj);
            })
            let keyIndex=this.props.jw_list_data.length;
            let obj1={key:keyIndex,id:6,title:'经纬大事记',content:'',status:1};
            // let obj2={key:keyIndex+1,id:7,title:'合作伙伴',content:'',status:1};
            let obj3={key:keyIndex+1,id:8,title:'留言反馈',content:'',status:1};
            jwListData.push(obj1);
            // jwListData.push(obj2);
            jwListData.push(obj3);
        }


        let gotoJW_menuLis=jwListData.map(({key,id,title,status})=>{
            if(status === 1){
                return(
                    <li key={key}><a onClick={()=>{this.onJingWeiNewsClick(key, id, title)}}>{title}</a></li>
                );
            }
            return null;
        });

        let firm_intro='北京经纬通达管理咨询有限公司多年来致力于从事税收筹划、高新企业认定、科技服务、财税服务、科技咨询、中小企业创业辅导等领域的咨询服务。先后为国内数千家企业、科研机构、院所等提供了一流的企业科研、财税等咨询服务，其中不乏全球500强企业和一些知名上市公司，尤具代表性的有中铁系统、城建系统、中建系统、市政系统等。';

        let firm_slogan=slogansData.map(({key,solganType,solganCon})=>{
            return(
                <div className={HeaderMenuSty.b_right_itemSty} key={key}>
                    <span>{solganType}</span>
                    <div className={HeaderMenuSty.b_right_conTextSty}>{solganCon}</div>
                </div>
            );
        });


        // 业务范围的li
        // bussinessListData
        // this.state.bussinessScopeListData.map({

        // })
        // this.state.

        let bsld=[];
        if(this.props.bussinessListData!=null){
            this.props.bussinessListData.map((item)=>{
                bsld.push(item);
            })
        }

        let bslItemData=[];
        if(this.props.bussinessItemConData!=null){
            this.props.bussinessItemConData.map((item)=>{
                bslItemData.push(item);
            })
        }

        let bussinessLis=bsld.map(({id,title,cover_link})=>{
            if(title!='咨询服务'){
                return(
                    <li className={HeaderMenuSty.bussiness_item_li} key={id}>
                        <div className={HeaderMenuSty.bussiness_itemNameSty}>{title}</div>
                            <ul className={HeaderMenuSty.con_ulSty}>
                            {
                                // con.map((con_item)=>{
                                //     return(
                                //         <li className={HeaderMenuSty.bussiness_conSty}>{con_item}</li>
                                //     )
                                // })
                                bslItemData.map((item, index)=>{
                                    if(item.cate_id==id){
                                        return (
                                            <li key={index} className={HeaderMenuSty.bussiness_conSty}><a onClick={()=>{this.onBussinessNewsClick(item.id)}}>{item.title}</a></li>
                                        )
                                    }
                                    return null
                                })
                            }
                            </ul>
                        {/* <div className={HeaderMenuSty.bussiness_itemBgmSty} style={{backgroundImage:`url(${baseUrl+cover_link})`}}></div> */}
                    </li>
                );
            }
           
        });

        let bussinessScope_imgLis=bsld.map(({id,title,cover_link})=>{
            if(title!='咨询服务'){
                return (
                    <li key={id}>
                        <div className={HeaderMenuSty.bussinessScope_img_itemBgSty} style={{backgroundImage:`url(${baseUrl+cover_link})`}}></div>
                    </li>
                )
            }
        });

        // 政策解读 动态显示框的li
        let gxqyData=[];
        let zjxmData=[];
        let zscqData=[];
        let zhzxData=[];
        let ztlbData=[];
        this.props.policyTypeData.sort((itemA,itemB)=>{
            return itemA.id-itemB.id;
        });
        
        if(this.props.policyData!=null && this.props.policyTypeData !=null && this.props.policyTypeData.length>=5){
            this.props.policyData.map((item)=>{
                if(this.props.policyTypeData[0].id == item.cate_id)
                    gxqyData.push(item)
                if(this.props.policyTypeData[1].id == item.cate_id)
                    zjxmData.push(item)
                if(this.props.policyTypeData[2].id == item.cate_id)
                    zscqData.push(item)
                if(this.props.policyTypeData[3].id == item.cate_id)
                    zhzxData.push(item)
                // if(this.props.policyTypeData[4].id == item.cate_id || this.props.policyTypeData[5].id == item.cate_id ){
                //     ztlbData.push(this.props.policyTypeData[4]);
                //     ztlbData.push(this.props.policyTypeData[5])
                // }
            })
        }
        ztlbData.push(this.props.policyTypeData[4]!=undefined?this.props.policyTypeData[4]:'');
        ztlbData.push(this.props.policyTypeData[5]!=undefined?this.props.policyTypeData[5]:'');
        // console.log('headerMenu查看props')
        // console.log(this.props)


        let gxqyLis=gxqyData.map((item,index)=>{
            if(index<9){
                return(
                    <li key={index} className={HeaderMenuSty.policyInfo_con_li}>
                        <div className={HeaderMenuSty.policyInfo_li_pointSty}></div>
                        <div className={HeaderMenuSty.policyInfo_li_item_titleSty}><a onClick={()=>{this.onPolicyNewsClick(item.cate_id,item.cate_desc,item.id)}}>{item.title}</a></div>
                    </li>
                );
            }
        });

        let zjxmLis=zjxmData.map((item,index)=>{
            if(index<3){
                return(
                    <li key={index} className={HeaderMenuSty.policyInfo_con_li}>
                        <div className={HeaderMenuSty.policyInfo_li_pointSty}></div>
                        <div className={HeaderMenuSty.policyInfo_li_item_titleSty}><a onClick={()=>{this.onPolicyNewsClick(item.cate_id,item.cate_desc,item.id)}}>{item.title}</a></div>
                    </li>
                );
            }
        });

        let zscqLis=zscqData.map((item,index)=>{
            if(index < 3){
                return(
                    <li key={index} className={HeaderMenuSty.policyInfo_con_li} >
                        <div className={HeaderMenuSty.policyInfo_li_pointSty}></div>
                        <div className={HeaderMenuSty.policyInfo_li_item_titleSty}><a onClick={()=>{this.onPolicyNewsClick(item.cate_id,item.cate_desc,item.id)}}>{item.title}</a></div>
                    </li>
                );
            }
        });

        let zhzxLis=zhzxData.map((item,index)=>{
            if(index < 3){
                return(
                    <li key={index} className={HeaderMenuSty.policyInfo_con_li} >
                        <div className={HeaderMenuSty.policyInfo_li_pointSty}></div>
                        <div className={HeaderMenuSty.policyInfo_li_item_titleSty}><a onClick={()=>{this.onPolicyNewsClick(item.cate_id,item.cate_desc,item.id)}}>{item.title}</a></div>
                    </li>
                );
            }
        });

        let ztlbLis=ztlbData.map((item, index)=>{
            return(
                <li key={index} className={HeaderMenuSty.policyInfo_ztlb_li} style={{backgroundImage:`url(${item.photo_link})`}} onClick={()=>{this.onZtlbItemClick()}}><a>{item.title}</a></li>
            );
        });

        // 经纬通达特色服务
        let featureServiceLis=featureServiceData.map(({key,itemName,itemIconBgColor,itemIcon})=>{
            return(
                <li key={key}>
                    <div className={HeaderMenuSty.b_m_li_leftIconDiv} style={{backgroundColor:itemIconBgColor}}>
                        <div className={HeaderMenuSty.b_m_li_leftIcon} style={{backgroundImage:`url(${itemIcon})`}}></div>
                    </div>
                    <div className={HeaderMenuSty.b_m_li_rightDiv}><a>{itemName}</a></div>
                </li>
            );
        });

        return(
            <div className={HeaderMenuSty.headerMenuDiv}>
                <div className={HeaderMenuSty.lineDiv}>
                    <div className={HeaderMenuSty.menuUlSty}>
                        {
                            menuListData.map(({key,itemName})=>{
                                if(this.props.policyData.length === 0 && key === 3) {
                                    return null;
                                } else {
                                    return(
                                        <li
                                            key={key}
                                            onMouseOver={()=>{this.onMenuItemMouseOver(key)}}
                                            onMouseLeave={this.onMenuItemMouseLeave}
                                            style={this.state.selectedIndex == key || this.props.currentSelectIndex == key ? menuItemSelectedSty : null}
                                        >
                                            <a onClick={()=>{this.onMenuItemClick(key)}} style={this.state.selectedIndex == key || this.props.currentSelectIndex == key ? menuItemSelected_a_sty:null}>{itemName}</a>
                                        </li>
                                    );
                                }
                            })
                        }
                    </div>

                    {/* 走进经纬的显示框 */}
                    <div
                        className={HeaderMenuSty.gotoJW}
                        style={{display:this.state.isShowAboutJW?'block':'none'}}
                        onMouseOver={()=>{this.onMenuItemMouseOver(1)}}
                        onMouseLeave={this.onMenuItemMouseLeave}
                    >
                        <div className={HeaderMenuSty.gotoJW_menuDiv}>
                            <ul>
                                {gotoJW_menuLis}
                            </ul>
                        </div>
                        <div className={HeaderMenuSty.gotoJW_splitLineDiv}>
                            <div className={HeaderMenuSty.gotoJW_leftSL}></div>
                            <div className={HeaderMenuSty.gotoJW_middleSL}></div>
                            <div className={HeaderMenuSty.gotoJW_rightSL}></div>
                        </div>

                        <div className={HeaderMenuSty.bottomDiv}>
                            <div className={HeaderMenuSty.bottom_left_div}>
                                <div className={HeaderMenuSty.b_left_titleSty}>走进经纬通达-关于我们-公司简介</div>
                                <div className={HeaderMenuSty.b_left_textSty} dangerouslySetInnerHTML={{__html:this.state.firmIntro}}>
                                      {/* {firm_intro} */}
                                </div>
                            </div>
                            <div className={HeaderMenuSty.gotoJW_bottomSL1_Sty}></div>
                            <div className={HeaderMenuSty.bottom_middle_div}>
                                <div className={HeaderMenuSty.b_m_left_div}>
                                    <div className={HeaderMenuSty.b_m_left_title}>经纬通达特色服务平台</div>
                                </div>

                                <div className={HeaderMenuSty.b_m_arrowDiv}></div>

                                <ul>
                                    {featureServiceLis}
                                </ul>
                            </div>
                            <div className={HeaderMenuSty.gotoJW_bottomSL2_Sty}></div>
                            <div className={HeaderMenuSty.bottom_right_div}>
                                <div className={HeaderMenuSty.b_right_titleSty}>走进经纬通达-关于我们-公司理念</div>

                                {firm_slogan}
                            </div>
                        </div>

                    </div>

                    {/*  业务范围的显示框*/}
                    <div
                        className={HeaderMenuSty.bussinessScope}
                        style={{display:this.state.isShowBussinessScopre?'block':'none'}}
                        onMouseOver={()=>{this.onMenuItemMouseOver(2)}}
                        onMouseLeave={this.onMenuItemMouseLeave}
                    >
                        <ul className={HeaderMenuSty.bussinessScope_ul}>
                            {bussinessLis}
                        </ul>
                        <div className={HeaderMenuSty.bussinessScope_img_divSty}>
                            <ul className={HeaderMenuSty.bussinessScope_img_ulSty}>
                               {bussinessScope_imgLis}
                            </ul>
                        </div>
                        <div className={HeaderMenuSty.clear}></div>
                    </div>

                    {/*  政策咨询的显示框*/}
                    <div
                        className={HeaderMenuSty.policyInfo}
                        style={{display:this.state.isShowPolicyInfo?'block':'none'}}
                        onMouseOver={()=>{this.onMenuItemMouseOver(3)}}
                        onMouseLeave={this.onMenuItemMouseLeave}
                    >
                        <ul className={HeaderMenuSty.policyInfo_ul}>
                            <li className={HeaderMenuSty.policyInfo_li}>
                                <div className={HeaderMenuSty.policyInfo_li_titleSty}>高新企业</div>
                                <ul className={HeaderMenuSty.gxqy_ul}>
                                    {gxqyLis}
                                </ul>
                            </li>

                            <li className={HeaderMenuSty.policyInfo_li}>
                                <div>
                                    <div className={HeaderMenuSty.policyInfo_li_titleSty}>资金项目</div>
                                    <ul className={HeaderMenuSty.zjxm_ul}>
                                        {zjxmLis}
                                    </ul>
                                </div>

                                <div>
                                    <div className={`${HeaderMenuSty.policyInfo_li_titleSty} ${HeaderMenuSty.policyInfo_zscqLi_titleSty}`}>知识产权</div>
                                    <ul className={HeaderMenuSty.zscq_ul}>
                                        {zscqLis}
                                    </ul>
                                </div>
                            </li>

                            <li className={HeaderMenuSty.policyInfo_li}>
                                <div>
                                    <div className={HeaderMenuSty.policyInfo_li_titleSty}>综合资讯</div>
                                    <ul className={HeaderMenuSty.zhzx_ul}>
                                        {zhzxLis}
                                    </ul>
                                </div>

                                <div>
                                    <div className={`${HeaderMenuSty.policyInfo_li_titleSty} ${HeaderMenuSty.policyInfo_ztlbLi_titleSty}`}>专题列表</div>
                                    <ul className={HeaderMenuSty.ztlb_ul}>
                                        {ztlbLis}
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );

    }
}


HeaderMenu.propTypes={
    currentSelectIndex:PropTypes.number.isRequired,
}


const mapStateToProps=(state)=>{

    return{
        headerMenuRouterPath:state.heareMenuRoutePathReducer.headerMenuRouterPath,
        bussinessListData:state.bussinessReducer.bussiness_list_data,
        bussinessItemConData:state.bussinessReducer.bussiness_con_data,
        jw_list_data:state.jwListReducer.jw_list_data,

        policyData:state.aboutPolicyReducer.policyData,
        policyTypeData:state.aboutPolicyReducer.policyTypeData,
    }
}

const mapDispatchToProps=(dispatch)=>{
    return{
        jumpRouterAction:(routerId)=>{dispatch(headerMenuRouterAction(routerId))},
        fetch_bussinessList:(method,params)=>{dispatch(fetch_bussinessList(method,params))},
        fetch_bussinessConData:(method,params)=>{dispatch(fetch_bussinessConData(method,params))},
        fetch_jw_list:(method,params)=>{dispatch(fetch_jw_list(method,params))},
        fetch_policy:(method,params)=>{dispatch(fetch_policy(method,params))},
        fetch_policy_type:(method,params)=>{dispatch(fetch_policy_type(method,params))},
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(withRouter(HeaderMenu));
